import { makeMatchesRegex } from './general';

// eslint-disable-next-line no-useless-escape
const PHONE_NUMBER_RE = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;

/**
 * Validator: Test that a value is a valid phone number.
 */
export const isPhoneNumber = makeMatchesRegex<string | number>(PHONE_NUMBER_RE);
